'use strict';

const AngularHelpers=require('../../../../dist-es6/client/angularCommon/angularHelpers');

module.exports=AngularHelpers.registerModule({
name:'fdc.features.personalSchedule',
dependencies:['ui.router'],
configs:[
require('./personalScheduleConfig')],

components:[
require('./personalScheduleController'),
require('./modals/scenarioSetupModalController'),
require('./components/rasterSchedule/rasterScheduleDirective'),
require('./components/timelineSchedule/timelineScheduleDirective'),
require('./components/incidentsSchedule/incidentsScheduleDirective')]});
//# sourceMappingURL=index.js.map
